import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import TpClientPaymentItem from './TpClientPaymentItem';

export default class TpClientPaymentItemWithoutActions extends TpClientPaymentItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'TP Client Payment ID',
        orderById: 'TpClientPaymentId',
        data: TpClientPaymentItem.GetDetailCellContent,
        minWidth: 20,
      },
      {
        label: 'Paid On',
        orderById: 'AppliedOn',
        data: 'AppliedOn',
        minWidth: 40,
      },
      {
        label: 'Payment Reference #',
        orderById: 'CheckNumber',
        data: TpClientPaymentItem.getPaymentReferenceCellContent,
        minWidth: 20,
      },
      { label: 'Paid', orderById: 'AmountApplied', data: 'AmountApplied', minWidth: 20 },
      { label: 'Client Invoice', orderById: 'AppliedToInvoiceId', data: 'AppliedToInvoiceId', minWidth: 20 },
    ];
  }
}
